import { Component, Input } from "@angular/core";

import { Discussion, DiscussionListConfig, User } from "../../../../models";
import { DiscussionListResult } from "../../../../interfaces";

import {
  DiscussionService,
  BookmarkService,
  UserService,
  ProfileService,
} from "../../../../services";

/*
  config.type are as follows
  all discussions = AllDiscussionsLatestFeed
  discussions from follows from profiles that the user follows = AllDiscussionsFollowFeed
  discussions searched = AllDiscussionsSearchFeed
  all community discussions = CommunityDiscussionsLatestFeed
  trending community discussions = CommunityDiscussionsTrendingFeed
  user's bookmarked discussions = BookmarkedDiscussionsFeed
*/

@Component({
  selector: "discussion-list",
  templateUrl: "./discussion-list.component.html",
  styleUrls: [
    "./discussion-list.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class DiscussionListComponent {
  constructor(
    private discussionService: DiscussionService,
    private bookmarkService: BookmarkService,
    private profileService: ProfileService,
    private userService: UserService
  ) {
    this.getCurrentUser();
  }

  private currentUser: User;
  private query: DiscussionListConfig;
  public results: Discussion[];
  public loading: boolean = false;
  public currentPage: number = 1;
  public totalPages: number = 1;

  @Input() limit: number;
  @Input()
  set config(config: DiscussionListConfig) {
    if (config) {
      this.query = config;
      this.currentPage = 1;
      this.runQuery();
    }
  }

  public getCurrentUser() {
    this.userService.currentUser.subscribe((userData: User) => {
      this.currentUser = userData;
    });
  }

  public setTagTo(event: any) {
    this.query.filters.tag = event;
    this.currentPage = 1;
    this.runQuery();
  }

  public fetchAllDiscussions() {
    this.discussionService
      .findMany(this.query)
      .subscribe((data: DiscussionListResult) => {
        this.results = data.discussions;
        this.totalPages = data.pages.total;
        this.loading = false;
      });
  }

  public fetchSearchedDiscussions() {
    this.discussionService
      .searchOne(this.query)
      .subscribe((data: DiscussionListResult) => {
        this.results = data.discussions;
        this.totalPages = data.pages.total;
        this.loading = false;
      });
  }

  public fetchBookmarkedDiscussions() {
    this.profileService
      .findMany(this.currentUser.username, this.query)
      .subscribe((data: DiscussionListResult) => {
        this.results = data.discussions;
        this.totalPages = data.pages.total;
        this.loading = false;
      });
  }

  public setPageTo(pageNumber: number) {
    this.currentPage = pageNumber;
    this.runQuery();
  }

  public runQuery() {
    this.loading = true;
    this.results = [];

    if (this.limit) {
      this.query.filters.limit = this.limit;
      this.query.filters.offset = this.limit * (this.currentPage - 1);
    }

    switch (this.query.type) {
      case "AllDiscussionsSearchFeed":
        this.fetchSearchedDiscussions();
        break;
      case "BookmarkedDiscussionsFeed":
        this.fetchBookmarkedDiscussions();
        break;
      default:
        this.fetchAllDiscussions();
    }

    window.scroll(0, 0);
  }
}
